// src/pages/ConfirmedWithdrawalsTab.js
import React, { useState, useEffect } from 'react';
import { fmtDateTimeUS } from '../../utils/dates';

export default function ConfirmedWithdrawalsTab() {
  const [withdrawals, setWithdrawals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const token = localStorage.getItem('token');

  useEffect(() => {
    const fetchConfirmed = async () => {
      try {
        setLoading(true);
        const resp = await fetch('/api/withdrawals/confirmed/', {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        });
        if (!resp.ok) throw new Error('Error loading confirmed-requests');
        const data = await resp.json();
        const cleaned = data.map(item => {
          let details = {};

          try {
            details = JSON.parse(item.payment_details || "{}");
          } catch (e) {
            console.warn("Ошибка парсинга payment_details:", e);
          }

          const contact =
            (details.phone && details.phone.trim()) ||
            (details.email && details.email.trim()) ||
            "";

          return {
            ...item,
            payment_details: contact,
          };
        });
        setWithdrawals(cleaned);
        console.log(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchConfirmed();
  }, [token]);

    const downloadReport = async () => {
    try {
        const resp = await fetch('/api/withdrawals/export-confirmed/', {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`,
        },
        });
        if (!resp.ok) {
        throw new Error(`Download error: ${resp.statusText}`);
        }
        const blob = await resp.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'confirmed_withdrawals.xlsx';
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
    } catch (err) {
        alert(err.message);
    }
    };

  return (
    <div className="bg-white p-6 rounded shadow overflow-x-auto">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-2xl font-semibold">Confirmed Withdrawals</h3>
        <button
        onClick={downloadReport}
        className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition"
        >
        Download Report
        </button>
      </div>

      {loading ? (
        <p>Loading…</p>
      ) : error ? (
        <p className="text-red-500">{error}</p>
      ) : (
        <table className="min-w-full text-sm">
          <thead className="border-b bg-gray-50">
            <tr>
              <th className="px-4 py-2 text-left">ID</th>
              <th className="px-4 py-2 text-left">User</th>
              <th className="px-4 py-2 text-left">Phone or Email</th>
              <th className="px-4 py-2 text-right">Amount</th>
              <th className="px-4 py-2 text-left">Updated At</th>
            </tr>
          </thead>
          <tbody>
            {withdrawals.map(w => (
              <tr key={w.id} className="border-b hover:bg-gray-100">
                <td className="px-4 py-2">{w.id}</td>
                <td className="px-4 py-2">{w.user_email}</td>
                  <td className="px-4 py-2">{w.payment_details}</td>
                <td className="px-4 py-2 text-right">
                  ${parseFloat(w.amount).toFixed(2)}
                </td>
                <td className="px-4 py-2">
                  {fmtDateTimeUS(w.updated_at)}
                </td>
              </tr>
            ))}

            {withdrawals.length === 0 && (
              <tr>
                <td colSpan="4" className="py-4 text-center text-gray-500">
                  No confirmed requests
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )}
    </div>
  );
}
